exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".link-action {\n    -ms-flex-item-align: right;\n        -ms-grid-row-align: right;\n        align-self: right;\n    margin-left: auto;\n    display: inline-block;\n}\n\n.link-wrapper {\n    display: -ms-flexbox;\n    display: flex;\n    padding: 10px;\n    cursor: pointer;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/evaluation/content/archive/tile.component.css
// module id = 772
// module chunks = 0